/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RdSAPAssessmentRatingBand } from './rdSAPAssessmentRatingBand';
import { RdSAPAssessmentReportRecommendation } from './rdSAPAssessmentReportRecommendation';


/**
 * A brief set of figures from the report as held in the data store.
 */
export interface RdSAPAssessmentReportEnergyData { 
    energyRating?: RdSAPAssessmentRatingBand;
    energyRatingPotential?: RdSAPAssessmentRatingBand;
    /**
     * The energy score (the number) usually between 1-100 but can be greater than 100
     */
    energyScore?: number;
    /**
     * The potential energy score (the number) usually between 1-100 but can be greater than 100
     */
    energyScorePotential?: number;
    /**
     * The EI energy score (the number) usually between 1-100 but can be greater than 100
     */
    environmentalImpactScoreCurrent?: number;
    /**
     * The EI energy score (the number) usually between 1-100 but can be greater than 100
     */
    environmentalImpactScorePotential?: number;
    /**
     * Lighting Cost per year in pounds. (This cost is as per RdSAP, no modifier to reflect changes in fuel prices)
     */
    lightingCostGBPCurrent?: number;
    /**
     * Heating Cost per year in pounds, (This cost is as per RdSAP, no modifier to reflect changes in fuel prices)
     */
    heatingCostGBPCurrent?: number;
    /**
     * Hot Water Cost per year in pounds, (This cost is as per RdSAP, no modifier to reflect changes in fuel prices)
     */
    hotWaterCostGBPCurrent?: number;
    /**
     * CO2 emissions per year in tonnes/year
     */
    co2EmissionsTonnesCurrent?: number;
    /**
     * An array of \"RdSAP Improvement measures\". This will be a list from 0 to N (maximum possible is 12).
     */
    improvements?: Array<RdSAPAssessmentReportRecommendation>;
}
export namespace RdSAPAssessmentReportEnergyData {
}


